<a style="cursor: pointer" class="text-nowrap">
  <ng-content></ng-content>
  <span *ngIf="arrowPosition == 'asc'" class="glyphicon glyphicon-triangle-top" aria-hidden="true"></span>
  <span *ngIf="arrowPosition == 'desc'" class="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
</a>
